module.exports = __webpack_public_path__ + "img/tratamento_lifestyle.9e312c29.jpg";